var React = require('react');

function IconFacebookAlt2Inline (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"facebook","transform":"translate(-0.066)"},[React.createElement("rect",{"data-name":"facebook_rect","width":"7","height":"5","transform":"translate(0.066 2.338)","fill":"none","key":0}),React.createElement("path",{"data-name":"facebook_path","d":"M83.668,10.824V5.893h1.684l.241-1.924H83.668v-1.2c0-.541.18-.962.962-.962h1.022V.06c-.241,0-.842-.06-1.5-.06a2.321,2.321,0,0,0-2.465,2.526V3.969H80V5.893h1.684v4.931Z","transform":"translate(-76.575)","fillRule":"evenodd","key":1})]));
}

IconFacebookAlt2Inline.defaultProps = {"viewBox":"0 0 9.011 10.824","className":"svg-inline"};

module.exports = IconFacebookAlt2Inline;

IconFacebookAlt2Inline.default = IconFacebookAlt2Inline;
